// components/LoadingState.js

import { Box, Flex, Text, Spinner } from "@chakra-ui/react";

export default function LoadingState({ title, description, view }) {

  const iconSrc = view === 'report' ? '/icon_rocket.svg' : '/icon_leading.svg';

  return (
    <Flex
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      alignItems="center"
      justifyContent="center"
      bg="white"
      borderRadius="12px"
      zIndex={10}
    >
      {/* Loading Frame Image with Circular Fade Mask */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="min(450px, 85%)"
        height="min(450px, 85%)"
        backgroundImage="url('/loading_frame.svg')"
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        // opacity={0.7}
        zIndex={1}
        // ✅ Circular mask - frame fades out from center to edges
        style={{
          WebkitMaskImage: 'radial-gradient(circle, transparent 30%, transparent 70%)',
          maskImage: 'radial-gradient(circle, black 30%, transparent 70%)',
        }}
      />

      {/* Content - Rocket + Text + Spinner */}
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        zIndex={11}
        position="relative"
      >

        {/* Rocket Icon with White Background - FIXED */}
        <Box
          width="48px"
          height="48px"
          bg="white"
          borderRadius="6px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={2}
          boxShadow="0 1px 3px rgba(0,0,0,0.05)"
        >
          <Box
            width="32px"
            height="32px"
            backgroundImage={`url('${iconSrc}')`}
            backgroundSize="contain"
            backgroundRepeat="no-repeat"
            backgroundPosition="center"
          />
        </Box>


        {/* Title - Bold and larger */}
        <Text
          fontSize="24px"
          fontWeight="600"
          color="#1A202C"
          textAlign="center"
          letterSpacing="-0.02em"
        >
          {title}
        </Text>

        {/* Description with inline spinner */}
        <Flex
          alignItems="center"
          gap={2}
          mt={2}
        >
          <Spinner
            size="sm"
            thickness="2px"
            speed="0.8s"
            emptyColor="gray.200"
            color="#CF008A"
          />
          <Text
            fontSize="md"
            fontWeight="semibold"
            color="#4F4F4F"
            textAlign="center"
          >
            {description}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
